// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'

import routes from './routes'
import store from './store'

import {count} from  './filters'


import AppView from './components/App.vue'


// Import Install and register helper items
Vue.filter('count', count)

Vue.use(require('vue-moment'));

// Resource logic
Vue.use(Resource)


Vue.use(VueRouter)

// Check local storage to handle refreshes
if (window.localStorage) {
  if (store.state.user !== window.localStorage.getItem('user')) {
    store.dispatch('doSetUser', JSON.parse(window.localStorage.getItem('user')))
    store.dispatch('doSetToken', window.localStorage.getItem('token'))
  }
}

Vue.http.interceptors.push((request, next) => {

   // Enable this when you have a backend that you authenticate against
  var headers = request.headers
  var token = window.localStorage.getItem('token')
  var user = JSON.parse(window.localStorage.getItem('user'))

   if (!headers.hasOwnProperty('Authorization')) {
     Vue.http.headers.common['Authorization'] = 'fb ' + user.id + ' ' + token
   }
  // continue to next interceptor without modifying the response
  // continue to next interceptor
  next((response) => {
    if(response.status == 401){
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user')
    }
  });
})


// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!window.localStorage.getItem('token') && window.localStorage.getItem('token') == null) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }  else if (to.fullPath == "/login" && window.localStorage.getItem('token') && window.localStorage.getItem('token') == null){
      next({
        path: '/'
      })
  }else {
    next()
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})





// WEBPACK FOOTER //
// ./src/main.js